import { ClientsTypes } from 'constants/clientTypes';
import { USER_ROLE } from 'constants/userRoles';
import { CALL_STATUS } from 'constants/callStatuses';
import { SCORE } from 'modules/cySecQuestionnaire/constants';
import { VerificationStatuses } from 'constants/verificationStatuses';
import { HUB } from 'constants/hubs';

export const CLIENT_TYPES_FORM = 'CLIENT_TYPES_FORM';

export const NEW_USER_FORM = 'NEW_USER_FORM';

export const ROLE_SELECT_ITEMS = [
  { label: 'Manager', value: USER_ROLE.MANAGER },
  { label: 'Admin', value: USER_ROLE.ADMIN },
];

export const ROLE_COUNTRY_MANAGER = [{ label: 'Manager', value: USER_ROLE.MANAGER }];

export const PERSONAL_DETAILS_SECTION = 'personalDetails';
export const ACCOUNT_DETAILS_SECTION = 'accountDetails';
export const ID_VERIFICATION_SECTION = 'idVerification';

export const ADD_USER_MODAL = 'ADD_USER_MODAL';

export const EMPLOYEE_FIELDS_TO_SEND = [
  'firstName',
  'lastName',
  'email',
  'role',
  'password',
  'managedCountries',
];

export const CLIENT_DETAILS_FIELDS_TO_SEND = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'email',
  'country',
  'city',
  'state',
  'zipCode',
  'addressLine1',
  'addressLine2',
  'phoneInfo',
  'whoReferred',
  'cxd',
  'password',
  'countryOfBirth',
  'nationality',
  'jurisdictionCountry',
  'jurisdiction',
  'tin',
  'tinOption',
  'tinOptionComment',
  'pep',
  'economicProfile',
  'typeOfCustomer',
  'completedKYC',
  'cySecClientType',
];

export const CLIENT_RISK_STATUSES = [
  { value: 'LOW', label: 'LOW' },
  { value: 'MEDIUM', label: 'MEDIUM' },
  { value: 'HIGH', label: 'HIGH' },
  { value: 'PROHIBITED', label: 'PROHIBITED' },
];

export const QUESTIONNAIRE_STATUSES = [
  { value: SCORE.LOW, label: 'Low' },
  { value: SCORE.MEDIUM, label: 'Medium' },
  { value: SCORE.HIGH, label: 'High' },
];

export const STATUS_LABEL = {
  [VerificationStatuses.NEW]: 'New',
  [VerificationStatuses.EDITING.LEAD1]: 'Lead 1',
  [VerificationStatuses.EDITING.LEAD2]: 'Lead 2',
  [VerificationStatuses.EDITING.LEAD3]: 'Lead 3',
  [VerificationStatuses.EDITING.LEAD4]: 'Lead 4',
  [VerificationStatuses.POSTED]: 'Posted',
  [VerificationStatuses.APPROVED]: 'Approved',
  [VerificationStatuses.REJECTED]: 'Rejected',
  [VerificationStatuses.FUNDED]: 'Funded',
  [VerificationStatuses.ACTIVE]: 'Active',
  [VerificationStatuses.DORMANT]: 'Dormant',
};

export const ACCOUNT_STATUSES = [
  { value: VerificationStatuses.NEW, label: STATUS_LABEL[VerificationStatuses.NEW] },
  {
    value: VerificationStatuses.EDITING.LEAD1,
    label: STATUS_LABEL[VerificationStatuses.EDITING.LEAD1],
  },
  {
    value: VerificationStatuses.EDITING.LEAD2,
    label: STATUS_LABEL[VerificationStatuses.EDITING.LEAD2],
  },
  {
    value: VerificationStatuses.EDITING.LEAD3,
    label: STATUS_LABEL[VerificationStatuses.EDITING.LEAD3],
  },
  {
    value: VerificationStatuses.EDITING.LEAD4,
    label: STATUS_LABEL[VerificationStatuses.EDITING.LEAD4],
  },
  { value: VerificationStatuses.POSTED, label: STATUS_LABEL[VerificationStatuses.POSTED] },
  { value: VerificationStatuses.APPROVED, label: STATUS_LABEL[VerificationStatuses.APPROVED] },
  { value: VerificationStatuses.REJECTED, label: STATUS_LABEL[VerificationStatuses.REJECTED] },
  { value: VerificationStatuses.FUNDED, label: STATUS_LABEL[VerificationStatuses.FUNDED] },
  { value: VerificationStatuses.ACTIVE, label: STATUS_LABEL[VerificationStatuses.ACTIVE] },
  { value: VerificationStatuses.DORMANT, label: STATUS_LABEL[VerificationStatuses.DORMANT] },
];

export const STATUS_LABEL_EU = {
  [VerificationStatuses.NEW]: 'New',
  [VerificationStatuses.EDITING.LEAD1]: 'Personal Details',
  [VerificationStatuses.EDITING.LEAD1_1]: 'Quiz',
  [VerificationStatuses.EDITING.LEAD2]: 'Account Creation',
  [VerificationStatuses.EDITING.LEAD4]: 'Pending Verification',
  [VerificationStatuses.POSTED]: 'Sent to Sumsub',
  [VerificationStatuses.APPROVED]: 'Account Approved',
  [VerificationStatuses.REJECTED]: 'Rejected',
  [VerificationStatuses.FUNDED]: 'Funded',
  [VerificationStatuses.ACTIVE]: 'Active',
  [VerificationStatuses.DORMANT]: 'Dormant',
};

export const ACCOUNT_STATUSES_EU = [
  { value: VerificationStatuses.NEW, label: STATUS_LABEL_EU[VerificationStatuses.NEW] },
  {
    value: VerificationStatuses.EDITING.LEAD1,
    label: STATUS_LABEL_EU[VerificationStatuses.EDITING.LEAD1],
  },
  {
    value: VerificationStatuses.EDITING.LEAD1_1,
    label: STATUS_LABEL_EU[VerificationStatuses.EDITING.LEAD1_1],
  },
  {
    value: VerificationStatuses.EDITING.LEAD2,
    label: STATUS_LABEL_EU[VerificationStatuses.EDITING.LEAD2],
  },
  {
    value: VerificationStatuses.EDITING.LEAD4,
    label: STATUS_LABEL_EU[VerificationStatuses.EDITING.LEAD4],
  },
  { value: VerificationStatuses.POSTED, label: STATUS_LABEL_EU[VerificationStatuses.POSTED] },
  { value: VerificationStatuses.APPROVED, label: STATUS_LABEL_EU[VerificationStatuses.APPROVED] },
  { value: VerificationStatuses.REJECTED, label: STATUS_LABEL_EU[VerificationStatuses.REJECTED] },
  { value: VerificationStatuses.FUNDED, label: STATUS_LABEL_EU[VerificationStatuses.FUNDED] },
  { value: VerificationStatuses.ACTIVE, label: STATUS_LABEL_EU[VerificationStatuses.ACTIVE] },
  { value: VerificationStatuses.DORMANT, label: STATUS_LABEL_EU[VerificationStatuses.DORMANT] },
];

export const STATUS_LABEL_HUB_MAPPER = {
  [HUB.FUSION_MARKETS]: STATUS_LABEL,
  [HUB.FUSION_MARKETS_X]: STATUS_LABEL,
  [HUB.FUSION_MARKETS_EU]: STATUS_LABEL_EU, //TODO FDS-3902: added new value
};

export const ACCOUNT_STATUSES_HUB_MAPPER = {
  [HUB.FUSION_MARKETS]: ACCOUNT_STATUSES,
  [HUB.FUSION_MARKETS_X]: ACCOUNT_STATUSES,
  [HUB.FUSION_MARKETS_EU]: ACCOUNT_STATUSES_EU, //TODO FDS-3902: added new value
};

export const CLIENT_TYPES_VALUES = [
  { label: 'Employee', value: ClientsTypes.EMPLOYEE, permissions: [USER_ROLE.ADMIN] },
  {
    label: 'IB Portal Client',
    value: ClientsTypes.IB_PORTAL_CLIENT,
    permissions: [USER_ROLE.ADMIN, USER_ROLE.MANAGER],
  },
  {
    label: 'IB Client',
    value: ClientsTypes.IB_CLIENT,
    permissions: [USER_ROLE.ADMIN, USER_ROLE.MANAGER],
  },
  {
    label: 'Client',
    value: ClientsTypes.CLIENT,
    permissions: [USER_ROLE.ADMIN, USER_ROLE.MANAGER],
  },
];

export const ALLOWED_ROLES_TO_CREATE_USER = [USER_ROLE.ADMIN, USER_ROLE.MANAGER];

export const NEW_IB_CLIENT_FORM = 'NEW_IB_CLIENT_FORM';

export const NEW_IB_PORTAL_CLIENT_FORM = 'NEW_IB_PORTAL_CLIENT_FORM';

export const CLIENT_TYPES_FORM_SETTINGS = {
  [ClientsTypes.EMPLOYEE]: { form: NEW_USER_FORM },
  [ClientsTypes.IB_PORTAL_CLIENT]: { form: NEW_IB_PORTAL_CLIENT_FORM },
  [ClientsTypes.IB_CLIENT]: { form: NEW_IB_CLIENT_FORM },
  [ClientsTypes.CLIENT]: { form: NEW_USER_FORM },
};

export const CALL_STATUS_RANGES = [
  { value: CALL_STATUS.ATTEMPTING_CONTACT_INITIAL, label: CALL_STATUS.ATTEMPTING_CONTACT_INITIAL },
  { value: CALL_STATUS.ATTEMPTING_CONTACT_WORKING, label: CALL_STATUS.ATTEMPTING_CONTACT_WORKING },
  {
    value: CALL_STATUS.ATTEMPTING_CONTACT_NO_CONTACT,
    label: CALL_STATUS.ATTEMPTING_CONTACT_NO_CONTACT,
  },
  { value: CALL_STATUS.OVER_3_ATTEMPTS_CALLED, label: CALL_STATUS.OVER_3_ATTEMPTS_CALLED },
  { value: CALL_STATUS.SOME_INTEREST, label: CALL_STATUS.SOME_INTEREST },
  { value: CALL_STATUS.STRONG_INTEREST, label: CALL_STATUS.STRONG_INTEREST },
  { value: CALL_STATUS.NOT_INTERESTED, label: CALL_STATUS.NOT_INTERESTED },
  { value: CALL_STATUS.DO_NOT_CONTACT, label: CALL_STATUS.DO_NOT_CONTACT },
  { value: CALL_STATUS.COMPLETED, label: CALL_STATUS.COMPLETED },
  { value: CALL_STATUS.WRONG_NUMBER, label: CALL_STATUS.WRONG_NUMBER },
  { value: CALL_STATUS.NO_CALL_STATUS, label: CALL_STATUS.NO_CALL_STATUS },
];

export const UPLOAD_ID_PHOTO_MODAL = 'UPLOAD_ID_PHOTO_MODAL';
export const UPLOAD_PROOF_MODAL = 'UPLOAD_PROOF_MODAL';
export const EDIT_PHOTO_ID_FORM = 'EDIT_PHOTO_ID_FORM';
export const EDIT_PROOF_FORM = 'EDIT_PROOF_FORM';
export const EDIT_ADDITIONAL_DOCUMENTS_FORM = 'EDIT_ADDITIONAL_DOCUMENTS_FORM';
export const EDIT_ADDITIONAL_DOCUMENTS_MODAL = 'EDIT_ADDITIONAL_DOCUMENTS_MODAL';

export const VERIFICATION_CHECK_QUESTION_TYPES = {
  NEW_ACCOUNT: 'New Account',
};

export const BUSINESSES_STATUS = {
  BUSINESSES_RISK: 'businesses_risk',
  NO_RISK: 'no_risk',
};

export const BUSINESSES_RISK_STATUSES = [
  { value: BUSINESSES_STATUS.BUSINESSES_RISK, label: 'Risk Businesses' },
  { value: BUSINESSES_STATUS.NO_RISK, label: 'No risk' },
];
